import { useMemo } from 'react'
import { format, Locale, parse } from 'date-fns'

import { LessonDto } from '../../service/types'

export const NEUTRAL_COLOR = '#E0E0E0'

export const formatLessonDate = (dateStr: string, locale: Locale): string => {
  const parsed = parse(dateStr, 'yyyy-MM-dd', new Date())
  return format(parsed, 'EEEE, d MMM yyyy', { locale })
}

export const getInstructorNames = (lesson: LessonDto): string => {
  return (lesson.instructors ?? []).map((i) => i.name).join(', ') || '\u2014'
}

export const useLessonGroups = (lessons: LessonDto[]) => {
  const groupedByDate = useMemo(() => {
    const groups: Record<string, LessonDto[]> = {}
    for (const lesson of lessons) {
      if (!groups[lesson.date]) groups[lesson.date] = []
      groups[lesson.date].push(lesson)
    }
    return groups
  }, [lessons])

  const sortedDates = useMemo(() => Object.keys(groupedByDate).sort().reverse(), [groupedByDate])

  return { groupedByDate, sortedDates }
}
